import React, { useCallback } from 'react';
import { usePersonalisationContext } from './context/PersonalisationContext';
import { PersonalisationModal } from './components/PersonalisationModal/index';
import { trackPersonalisationStart } from './utilities/tracking.js';
import { useLocale } from './context/LocaleContext.jsx';

/**
 * @returns {(import('react').ReactElement | null)}
 */
function App() {
  const { product, personalisationSteps, setStart, personalisationModalOpen, setPersonalisationModalOpen, start } =
    usePersonalisationContext();
  const { formatPrice } = useLocale();

  const handleOpenPersonalisationModal = useCallback(() => {
    if (!start) {
      setStart(true);
      // Modal will open automatically after data is loaded
    } else {
      setPersonalisationModalOpen(true);
    }
    if (product) {
      trackPersonalisationStart({
        totalSteps: personalisationSteps.size
      });
    }
  }, [product, start, setStart, setPersonalisationModalOpen, personalisationSteps.size]);

  const handleClosePersonalisationModal = useCallback(() => {
    setPersonalisationModalOpen(false);
  }, [setPersonalisationModalOpen]);

  if (!product) {
    return <div>Error loading product data</div>;
  }

  const personaliseCta = window.personalisation.personaliseCtaText || 'Personalise';
  const { price } = product;

  return (
    <>
      <button
        className="button button--primary button--orange button--full-width"
        onClick={handleOpenPersonalisationModal}
      >
        {personaliseCta}
      </button>
      <PersonalisationModal isOpen={personalisationModalOpen} onClose={handleClosePersonalisationModal} />
    </>
  );
}

export default App;
